<template>
  <div>
    <div class="top_div">
      <img class="home_banner" :src="bgImg" />
      <!-- <div id="box" class="center"></div> -->
      <div class="map_div">
        <div id="baidumap" class="map"></div>
        <div class="info">
          <!-- <div class="info_bg">
            </div> -->
          <p>联系我们</p>
          <p class="info_en_title">Contact Us</p>
          <div class="info_item">
            <p class="phonegone">&emsp;&emsp;&emsp;&emsp;</p>
            <div class="info_msg">
              <p class="litter_line_top phonegone"></p>

              <p class="p_title_sub">地址：{{ List[0].address }}</p>
              <p class="p_title_sub">邮箱：{{ List[0].email }}</p>
              <div class="info_phone_div">
                <p class="p_title_sub">电话：</p>
                <div class="info_phone">
                  <p class="p_title_sub">{{ List[0].phone }}</p>
                  <p class="p_title_sub">{{ List[0].tel }}</p>
                </div>
              </div>
              <div class="info_en">
                <div class="info_phone_div">
                  <p class="p_title_sub content_en">Add&ensp;:&ensp;</p>
                  <div>
                    <p class="p_title_sub content_en">{{ List[0].addEn }}</p>
                  </div>
                </div>
                <p class="p_title_sub content_en">
                  Mail&ensp;:&ensp;{{ List[0].email }}
                </p>
                <div class="info_phone_div">
                  <p class="p_title_sub content_en">Tel&ensp;&ensp;:</p>
                  <div class="info_phone">
                    <p class="p_title_sub content_en">
                      &ensp;{{ List[0].phone }}
                    </p>
                    <p class="p_title_sub content_en">
                      &ensp;{{ List[0].tel }}
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      bgImg: "",
      List: [
        {
          phone: "",
          tel: "",
          address: "",
          email: "",
        },
      ],
    };
  },
  components: {},
  mounted() {
    this.Init();
  },
  methods: {
    initMap() {
      var map = new BMap.Map("baidumap", {
        enableBizAuthLogo: false,
      });
      var point = new BMap.Point(121.472399, 29.900732);
      map.enableScrollWheelZoom(true);
      map.centerAndZoom(point, 18);
      map.addEventListener("zoomend", function () {
        // alert("地图缩放至：" + this.getZoom() + "级");
        map.panTo(new BMap.Point(121.472399, 29.900732));
      });
      window.setTimeout(function () {
        map.panTo(new BMap.Point(121.472399, 29.900732));
      }, 2000);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中
    },
    Init() {
      this.getBgImg();
      this.initMap();
      this.getSimple();
    },
    getBgImg() {
      let that = this;
      this.$axios
        .get("app/pagerimg/list")
        .then(function (response) {
          // console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.bgImg = response.data.page.list[3].img;
            // console.log(that.bgImg);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
    getSimple() {
      let that = this;
      this.$axios
        .get("app/callus/list")
        .then(function (response) {
          console.log(response);
          var status = response.data.code;
          if (status === 0) {
            that.List = response.data.page.list;
            console.log(that.List);
            // sessionStorage.setItem("input", "null");
          }
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.top_div {
  height: 100%;
  position: relative;
}

.home_banner {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
  --swiper-pagination-color: #ec8938;

  div {
    width: 100%;
    height: 50vw;
    margin-left: auto;
    margin-right: auto;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
}

.map_div {
  width: 140rem;
  height: 60rem;
  display: flex;
  position: absolute;
  margin: auto;
  left: 0;
  right: 0;
  top: 20%;

  .map {
    z-index: 1;
    width: 60rem;
    height: 100%;
  }

  .info {
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.4);
    padding-top: 5rem;
    padding-left: 5rem;
    color: white;
    font-size: 3.6rem;
    font-family: thin;
    text-align: left;
    line-height: 3.6rem;
    z-index: 1;
    // padding: 10rem 5rem;
    width: 80rem;
    height: 100%;
    position: absolute;
    left: 60rem;
    background-position: center top;
    background-size: cover;
    overflow: hidden;
    text-shadow: 4px 4px 4px rgba(0, 73, 133, 0.6);

    .info_en_title {
      font-size: 3rem;
    }

    .info_item {
      display: flex;
    }

    .info_msg {
      // margin:0 15rem;
      .info_phone_div {
        display: flex;

        .info_phone {
        }
      }

      p {
        margin-bottom: 0;
        text-shadow: 3px 3px 3px rgba(0, 73, 133, 0.6);
      }

      .p_title_sub {
        font-family: light;
        font-size: 2.4rem;
      }

      .info_en {
        margin-top: 2rem;
      }

      .content_en {
        font-size: 1.8rem;
        line-height: 1.5;
      }

      .litter_line_top {
        margin: 1rem 0;
        background-color: var(--textWhiteColor40);
        box-shadow: 3px 3px 3px rgba(0, 73, 133, 0.6);
        height: 7rem;
        width: 1px;
      }
    }
  }

  .info::after {
    // border: 1px solid #000000cc;
    // margin: -30px;
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: -1;
    background-image: url('../../static/img/品牌页-海报-标注11.jpg');
    background-position: center top;
    background-size: cover;
    background-attachment: fixed;
    -webkit-filter: blur(10px);
    -moz-filter: blur(10px);
    -ms-filter: blur(10px);
    -o-filter: blur(10px);
    filter: blur(10px);
  }

  .info_bg {
    width: 84rem;
    margin: -5px;
    content: '';
    position: absolute;
    top: 0;
    // left: 0;
    right: 20%;
    bottom: 0;
    background-color: rgba(255, 255, 255, 0.8);
    // z-index: -1;
    background-image: url('../../static/img/品牌页-海报-标注11.jpg');
    background-position: center top;
    background-size: cover;
    background-attachment: fixed;
    // -webkit-filter: blur(10px);
    // -moz-filter: blur(10px);
    // -ms-filter: blur(10px);
    // -o-filter: blur(10px);
    // filter: blur(10px);
  }
}

@media screen and (max-width: 1200px) {
  .top_div {
    height: 95vh;
  }

  .home_banner {
    height: 100%;
    object-fit: none !important;
    object-position: bottom;
  }

  .flex_container {
    width: 80%;
  }

  .map_div {
    width: 90vw;
    height: 100vh;
    top: 10%;
    flex-direction: column-reverse;

    .map {
      height: 25rem;
      width: 100%;
      position: absolute;
      top: 55rem;
    }

    .info {
      height: auto;
      left: 0;
      top: 5rem;
      right: 0;
      width: 100%;
      padding: 3rem 0 3rem 2rem;
      font-size: 2.8rem;

      .info_item {
        .phonegone {
          display: none;
        }
      }

      .info_msg {
        margin: 3rem 0 0;

        .p_title_sub {
          font-size: 1.8rem;
        }
      }
    }

    .info::after {
      background-position: center;
      background-size: auto;
      background-attachment: unset;
    }
  }
}
</style>
